import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import tradeDataStore from "@/store/tradeDataStore";
import React from "react";
import { Role } from "@/lib/interfaces and Enums/ENUMRole";
import { statusFromAwarded } from "../colDefs/colDefsShared";
import { confirmNPVandRecouponLegsInTrade } from "../cellRenderers/MainTableActionSummaryESLevel/StructureTypeMainBlotterCellRenderer/structureTypeHelpers";

export function formatSecurityWithUnwind(data: ExecutionStrategy): string[] {
  const formattedSecurities: string[] = [];

  if (data.role == "OP") {
    if (
      data.executionRequestCounterParties &&
      data.executionRequestCounterParties.length > 0
    ) {
      if (
        data.executionRequestCounterParties[0].legs &&
        data.executionRequestCounterParties[0].legs.length > 0
      ) {
        data.executionRequestCounterParties[0].legs.forEach((leg) => {
          if (leg.security) {
            if (
              leg.unwind &&
              leg.unwind !== "NPV" &&
              leg.unwind !== "Recoupon"
            ) {
              formattedSecurities.push(`${leg.direction} ${leg.security}`);
            } else if (leg.unwind === "NPV" || leg.unwind === "Recoupon") {
              formattedSecurities.push(
                `${leg.unwind}: ${leg.direction} ${leg.security}`,
              );
            } else {
              formattedSecurities.push(`${leg.direction} ${leg.security}`);
            }
          }
        });
      }
    }
  } else if (data.role == "RP") {
    if (data.legs && data.legs.length > 0) {
      data.legs.forEach((leg) => {
        if (leg.securityName) {
          if (leg.unwind && leg.unwind !== "NPV" && leg.unwind !== "Recoupon") {
            formattedSecurities.push(`${leg.securityName}`);
          } else if (leg.unwind === "NPV") {
            formattedSecurities.push(`${leg.unwind}: ${leg.securityName}`);
          } else if (
            data.status &&
            leg.unwind === "Recoupon" &&
            statusFromAwarded.includes(data.status)
          ) {
            formattedSecurities.push(`${leg.unwind}: ${leg.securityName}`);
          } else {
            formattedSecurities.push(`${leg.securityName}`);
          }
        }
      });
    }
  }

  return formattedSecurities;
}

const MainStructureTooltip = (params: any) => {
  const renderSecurityLine = (
    unwindSecurityName: string,
    index: number,
  ): JSX.Element => {
    // Check for both separators: ":" (OP) and " - " (RP)
    const colonParts = unwindSecurityName.split(": ", 2);
    // const dashParts = unwindSecurityName.split(" - ");

    // Handle NPV/Recoupon with colon separator (OP role)
    if (
      colonParts.length === 2 &&
      (colonParts[0] === "NPV" || colonParts[0] === "Recoupon")
    ) {
      return (
        <div className="py-1" key={index}>
          - <span className="font-bold underline">{colonParts[0]}</span>:{" "}
          {colonParts[1]}
        </div>
      );
    }

    return (
      <div className="py-1" key={index}>
        - {unwindSecurityName}
      </div>
    );
  };

  if (params.data) {
    const data = params.data as ExecutionStrategy;
    const currentTradeData = tradeDataStore((state) => state.tradeData);
    const thisTrade = currentTradeData.find((trade) => trade.esid == data.esid);

    if (!thisTrade) {
      return;
    }
    const {
      containsNPV,
      containsRecoupon,
      // totalBlockCount,
      // NPVBlockCount,
      // RecouponBlockCount,
    } = confirmNPVandRecouponLegsInTrade(thisTrade);

    // const elementsToRender = [
    //   {
    //     name: "NPV",
    //     toShow: containsNPV,
    //     count: NPVBlockCount,
    //     total: totalBlockCount,
    //   },
    //   {
    //     name: "Recoupon",
    //     toShow: containsRecoupon,
    //     count: RecouponBlockCount,
    //     total: totalBlockCount,
    //   },
    // ];

    if (!containsNPV && !containsRecoupon) {
      return null;
    }
    //hide Recoupon TT on structure for RP when not at awarded.
    if (thisTrade.status) {
      if (
        !containsNPV &&
        containsRecoupon &&
        thisTrade.role == Role.RP &&
        !statusFromAwarded.includes(thisTrade.status)
      ) {
        return null;
      }
    }

    return (
      <div
        className="bg-gray-300  p-2 shadow-lg dark:bg-[#171717]"
        //   style={{ background: "white", padding: "6px", border: "1px solid #ccc" }}
      >
        {/* <div className="pb-2">Total Blocks: {totalBlockCount}</div> */}
        {/* {elementsToRender.map((element) => {
          return (
            <div key={element.name} className="flex w-full flex-row pb-1">
              {element.toShow ? (
                <div className="flex w-full justify-start gap-2 ">
                  <div>
                    {element.count} of {totalBlockCount}
                  </div>
                  <div>{element.name}</div>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          );
        })} */}
        {formatSecurityWithUnwind(thisTrade).map((unwindSecurityName, index) =>
          renderSecurityLine(unwindSecurityName, index),
        )}
      </div>
    );
  }
};
export default MainStructureTooltip;
